// extracted by mini-css-extract-plugin
module.exports = {"richTextContainer":"CourseOverviewLearningOutcomes_richTextContainer__8RmEx"};